import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";

import { Link as RouterLink } from "react-router-dom";
const BreadCrumb = ({ items, textColor }) => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ height: "40px", color: textColor && "#94A3B8" }}
    >
      {items.map((item, index) => {
        if (index === items.length - 1) {
          return (
            <Typography
              key={item.text}
              variant="body1"
              sx={{ color: textColor ? "#00C9A7" : "text.main" }}
            >
              {item.text}
            </Typography>
          );
        }
        return (
          <Link
            component={RouterLink}
            to={item.href}
            key={item.text}
            // onClick={() => (setValue ? setValue(0) : "")}
            underline="hover"
            sx={{
              color: textColor ? textColor : "text.primary",
              fontWeight: 500,
              fontSize: "0.85rem",
              "&:hover": {
                color: "text.link",
              },
            }}
          >
            {item.text}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadCrumb;
